import { NO_BACKUP_CODES_AVAILABLE } from 'common/constants/auth';
import { Grid, LoadingState } from 'components/ui';
import { Item, ItemCode, ItemsContainer, NoBackupCodesText } from 'pages/Auth/components/BackupCodes/BackupCodes.styles';
import { BACKUP_CODES_TEST_IDS } from 'pages/Auth/components/BackupCodes/BackupCodes.testIds';
import type { BackupCodesInfoProps } from './BackupCodesInfo.props';

const BackupCodesInfo = ({
  backupCodes,
  disabledGenerate = false,
  isGeneratingBackupCodes = false,
  isAuthFlowStep = false,
}: BackupCodesInfoProps) => (
  <ItemsContainer container justifyContent="center" alignItems="center" isAuthFlowStep={isAuthFlowStep}>
    {disabledGenerate && (
      <Grid container justifyContent="center" alignItems="center">
        <NoBackupCodesText>{NO_BACKUP_CODES_AVAILABLE}</NoBackupCodesText>
      </Grid>
    )}

    {!disabledGenerate && backupCodes.length === 0 ? (
      <Grid container justifyContent="center" alignItems="center">
        {isGeneratingBackupCodes
          ? <LoadingState minHeight={80} />
          : <NoBackupCodesText>{NO_BACKUP_CODES_AVAILABLE}</NoBackupCodesText>}
      </Grid>
    ) : (
      !disabledGenerate
      && backupCodes.map(code => (
        <Item isAuthFlowStep={isAuthFlowStep} key={`bk-codes-${code}`} size={{ xs: 12, sm: isAuthFlowStep ? 6 : 'auto' }}>
          <ItemCode data-testid={BACKUP_CODES_TEST_IDS.codeValue} isAuthFlowStep={isAuthFlowStep}>{code}</ItemCode>
        </Item>
      ))
    )}
  </ItemsContainer>
);

export default BackupCodesInfo;
